var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "clvr-config-category" },
    [
      _c("h1", { staticClass: "clvr-config-category__title" }, [
        _vm._v(_vm._s(_setup.$t(_vm.context + ":" + _vm.category.label))),
      ]),
      _vm._v(" "),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }